import Block from './Block'
import Instafeed from '../util/Instafeed'
import App from '../App'

export default class Instagram extends Block {
  onEnterCompleted() {
    this.feed = new Instafeed({
      accessToken: window.AccessToken,
      clientId: window.ClientId,
      userId: window.UserId,
      apiTimeout: 10000,
      target: this.el,
      template: '<div class="instagram"><a href="{{link}}" target="_blank" rel="noopener" data-scroll data-scroll-speed=\'1\'><img src="{{image}}" alt="{{type}} instagram"/></a></div>',
      get: 'user',
      sortBy: 'most-recent',
      limit: 4,
      after: () => {
        const images = this.el.querySelectorAll('.instagram a')

        for (let i = 0; i < images.length; i++) {
          images[i].dataset.scrollSpeed = i * 0.5
        }

        setTimeout(() => {
          App.smoothScroll.update()
          App.background.updateSectionsPosition()
        }, 500)
      }
    })

    this.feed.run()
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Instagram.js